<template>
    <div>
        <div class="product_menu">
            <dl class="pageCenter" id="product_menu">
                <dt><a href="#page1" title="唐麦麦克风i5">Tangmai i5</a></dt>
                <dd data-menuanchor="page2"><a href="#page2">概览</a></dd>
                <dd data-menuanchor="page3"><a href="#page3">音质</a></dd>
                <dd data-menuanchor="page4"><a href="#page4">设计</a></dd>
                <dd data-menuanchor="page5"><a href="#page5">性能</a></dd>
                <dd data-menuanchor="page6"><a href="#page6">体验</a></dd>
                <dd data-menuanchor="page7"><a href="#page7">品质</a></dd>
                <dd data-menuanchor="page8"><a href="#page8">参数</a></dd>
            </dl>
        </div>
        <div id="product" style="z-index:1;" v-if="platform == 1">
            <!-- 头部 -->
            <div class="section header active fp-auto-height">
                <v-header></v-header>

                <div class="product_menu2">
                    <dl class="pageCenter">
                        <dd data-menuanchor="page2"><a href="#page2">概览</a></dd> 
                        <dd data-menuanchor="page3"><a href="#page3">音质</a></dd>
                        <dd data-menuanchor="page4"><a href="#page4">设计</a></dd>
                        <dd data-menuanchor="page5"><a href="#page5">性能</a></dd>
                        <dd data-menuanchor="page6"><a href="#page6">体验</a></dd>
                        <dd data-menuanchor="page7"><a href="#page7">品质</a></dd>
                        <dd data-menuanchor="page8"><a href="#page8">参数</a></dd>
                    </dl>
                </div>
            </div>

            <div class="section product_li" style=" background:url(http://wx4.sinaimg.cn/large/0067mezugy1fy1rptpdqmj31hc0kun0k.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 50%; margin-top: -50px;"><img src="../../assets/img/i5/1.png" style="margin-right: -640px;" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx3.sinaimg.cn/large/0067mezugy1fy1rpu561tj31hc0kujwc.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 50%; margin-top: -130px;"><img src="../../assets/img/i5/2.png" style="margin-right: 800px;"/></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx2.sinaimg.cn/large/0067mezugy1fy1rpurc63j31hc0ku0vx.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 15%;"><img src="../../assets/img/i5/3.png" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx4.sinaimg.cn/large/0067mezugy1fy1rpv52qoj31hc0kujum.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 50%; margin-top: -70px;"><img src="../../assets/img/i5/4.png" style="margin-right: -600px;" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx2.sinaimg.cn/large/0067mezugy1fy1slk7c36j31hc0ku14e.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 10%;"><img src="../../assets/img/i5/5.png" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx2.sinaimg.cn/large/0067mezugy1fy1rpw905wj31hc0ku0w0.jpg) center; background-size:auto 100%;">
            <p class="p1" style="top: 15%;"><img src="../../assets/img/i5/6.png" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://wx1.sinaimg.cn/large/0067mezugy1fy1rpwobxij31hc0ku0t6.jpg) center; background-size:auto 100%;">
            <div class="pageCenter">
            	<p style=" top:20%; text-align:left; width:100%;"><img src="../../assets/img/i5/7.png" /></p>
				<div class="product_data" style="bottom: 20%; color: #000000;">
                	<ul>
                    	<li class="left">
                        	<div class="data_box"><p class="data_p1">指向特性</p>
                        	<p class="data_p2">Directional characteristics</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">心形</p>
                            <p class="data_p2">heart-shaped</p>
                            </div>
                        </li>
						<li>
                            <div class="data_box"><p class="data_p1">频响范围</p>
                        	<p class="data_p2">Frequency Response</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">100-10000HZ</p>
                            <p class="data_p2">20-20000HZ</p>
                            </div>
                        	
                        </li>
						<li class="left">
                        	<div class="data_box"><p class="data_p1">拾音器</p>
                        	<p class="data_p2">Pickup</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">14mm电容式音头</p>
                            <p class="data_p2">14mm capacitive sound head</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">续航时间</p>
                        	<p class="data_p2">Endurance time</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">约8h</p>
                            <p class="data_p2">About 8h</p>
                            </div>
                        </li>
						<li class="left">
                        	<div class="data_box"><p class="data_p1">电池容量</p>
                        	<p class="data_p2">Battery capacity</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">600mAh</p>
                            <p class="data_p2">600mAh</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">音噪比</p>
                        	<p class="data_p2">Signal-to-noise ratio</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">58db</p>
                            <p class="data_p2">58db</p>
                            </div>
                        </li>
						
						<li class="left">
                        	<div class="data_box"><p class="data_p1">充电时间</p>
                        	<p class="data_p2">Charging time</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">约2h</p>
                            <p class="data_p2">About 2h</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">重量</p>
                        	<p class="data_p2">Weight</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">185g</p>
                            <p class="data_p2">185g</p>
                            </div>
                        </li>
						
                    </ul>
                </div>
				
            </div>
        </div>

            <!-- 尾部 -->
            <div class="section fp-auto-height fp-section">
                <v-footer></v-footer>
            </div>
            
        </div>

        <div id="mobile" v-else>
            <!--手机端头部-->
            <v-header></v-header>
            <div class="mobile_pageMain">
                <div class="tools">
                    <span class="span1">产品</span>
                    <span class="span2">唐麦 I5</span>
                </div>
                <img class="productImg" style="margin-top:40px;" src="http://wx4.sinaimg.cn/large/0067mezugy1fy1sqlmqoej30u0104q6q.jpg" />
                <img class="productImg" src="http://wx3.sinaimg.cn/large/0067mezugy1fy1sqm3g2aj30u0104dlx.jpg" />
                <img class="productImg" src="http://wx3.sinaimg.cn/large/0067mezugy1fy1sqmv035j30u0104tcr.jpg" />
                <img class="productImg" src="http://wx4.sinaimg.cn/large/0067mezugy1fy1sqn7kjij30u0104tcj.jpg" />
                <img class="productImg" src="http://wx4.sinaimg.cn/large/0067mezugy1fy1sqno8smj30u0104gpg.jpg" />
                <img class="productImg" src="http://wx2.sinaimg.cn/large/0067mezugy1fy1sqo1ilbj30u01040wi.jpg" />
                <img class="productImg" src="http://wx2.sinaimg.cn/large/0067mezugy1fy1sqolsytj30u0104tal.jpg" />
            </div>
            <v-footer></v-footer>
        </div>
        <!-- 回到顶部 -->
        <a href="#page1"><goto-top></goto-top></a>
    </div>
</template>
<script>
    //引入fullpage
    import "../../assets/libs/fullpage/jquery.fullPage.css"
    import "../../assets/libs/fullpage/jquery.fullPage.min.js"
    import "../../assets/css/style.css"
    export default {
        data() {
            return {
                platform: 1 //1 pc端   2 mobile端
            }
        },
        mounted() {
            if ($(window).width() > 786) {
                this.platform = 1;
                var $mlNav = $('.product_menu');
                $('#product').fullpage({
                    verticalCentered: !1,
                    navigation: !0,
                    anchors: ['page1', 'page2', 'page3', 'page4', 'page5', 'page6', 'page7', 'page8', 'page9', 'page10'],
                    menu: '#product_menu',
                    onLeave: function(index, nextIndex, direction) {
                        if (index == 2 && direction == 'up') {
                            $mlNav.animate({
                                top: -100
                            }, 0);
                        } else if (index == 1 && direction == 'down') {
                            $mlNav.animate({
                                top: 0
                            }, 500);
                            $(".headmenu_two").hide();
                        }
                        if (nextIndex == 1) {
                            $mlNav.animate({
                                top: -100
                            }, 0);
                        }
                        if (nextIndex == 10) {
                            $mlNav.hide();
                        } else {
                            $mlNav.show();
                        }
                    },
                    afterLoad: function(anchorLink, index) {
                        //$(".product_li").css("height", $("#product").height());
                        if (index == 3) {
                            $(".product_menu dt a").css("color", "#ffffff");
                            $(".product_menu dd a").css("color", "#ffffff");
                            $(".product_menu dd.active a").css("color", "#000000");
                            $(".product_menu dt a").mouseover(function() {
                                $(this).css("color", "#000000");
                            });
                            $(".product_menu dd a").mouseover(function() {
                                $(this).css("color", "#000000");
                            });
                            $(".product_menu dt a").mouseleave(function() {
                                $(this).css("color", "#ffffff");
                            });
                            $(".product_menu dd a").mouseleave(function() {
                                $(this).css("color", "#ffffff");
                            });
                        } else if (index == 6 || index == 8) {
                            $(".product_menu dt a").css("color", "#9e9e9f");
                            $(".product_menu dd a").css("color", "#9e9e9f");
                            $(".product_menu dd.active a").css("color", "#000000");
                            $(".product_menu dt a").mouseover(function() {
                                $(this).css("color", "#000000");
                            });
                            $(".product_menu dd a").mouseover(function() {
                                $(this).css("color", "#000000");
                            });
                            $(".product_menu dt a").mouseleave(function() {
                                $(this).css("color", "#9e9e9f");
                            });
                            $(".product_menu dd a").mouseleave(function() {
                                $(this).css("color", "#9e9e9f");
                            });
                        } else {
                            $(".product_menu dt a").css("color", "#9e9e9f");
                            $(".product_menu dd a").css("color", "#9e9e9f");
                            $(".product_menu dd.active a").css("color", "#ffffff");
                            $(".product_menu dt a").mouseover(function() {
                                $(this).css("color", "#ffffff");
                            });
                            $(".product_menu dd a").mouseover(function() {
                                $(this).css("color", "#ffffff");
                            });
                            $(".product_menu dt a").mouseleave(function() {
                                $(this).css("color", "#9e9e9f");
                            });
                            $(".product_menu dd a").mouseleave(function() {
                                $(this).css("color", "#9e9e9f");
                            });

                        }

                        /*回到顶部*/
                        if (index == 1 || index == 2) {
                            $(".gotoTop").hide();
                        } else {
                            $(".gotoTop").show();
                        }
                    }
                })
            } else {
                this.platform = 2;
            }
        },
        destroyed() {
            var html = document.querySelector("html");
            var width = html.getBoundingClientRect().width;
            //设置 1rem = width/16
            if (width >= 768) {
                //去除fullpage插件设置的100%高度和隐藏溢出
                $("html, body").removeAttr("style");
                $("html, body").removeAttr("class");
            }
        }
    }
</script>
<style scoped>
    @media (min-width: 768px) {
        .header-wrap {
            position: relative !important;
        }
    }
    
    .product_data .data_p1 {
        color: #333333;
    }
    
    .product_data li {
        border-bottom-color: #848484;
    }
</style>


// WEBPACK FOOTER //
// src/pages/products/i5.vue